
export default {
  vessel: {
    copyright: {
      fontSize: 'sm',
      fontWeight: 'light',
      color: 'grey-darkest'
    },
    social: {
      fontSize: 'md',
      color: 'grey-dark'
    }
  },
  data() {
    return {
      socialAccounts: [
        {
          name: 'Facebook',
          icon: 'facebook',
          url: 'https://www.facebook.com/'
        }
      ]
    }
  },
  computed: {
    copyright() {
      const title = this.$t('footer.copyrightTitle')
      const rights = this.$t('footer.rightsReserved')

      return `${title}. ${rights}`
    }
  }
}
